import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseRules } from '../design/rules';
import { logos, logoBgColors } from '../form/enum/icon';
import { getGroup } from 'api/flow';
import Org from '@/components/organization';
export default {
  components: {
    Org: Org
  },
  name: 'Basic',
  props: {
    base: {
      type: Object,
      default: function _default() {}
    },
    selectData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      logos: logos,
      logoBgColors: logoBgColors,
      rules: baseRules(this),
      groups: [],
      orgVisible: false
    };
  },
  computed: {
    // 选中对象回显
    selected: function selected() {
      try {
        return [].concat(_toConsumableArray(this.base.visible.staff), _toConsumableArray(this.base.visible.department)).splice(0, 3);
      } catch (error) {
        return [];
      }
    },
    // 选中回显Org组件
    selectedOrg: function selectedOrg() {
      try {
        var _this$base$visible = this.base.visible,
          department = _this$base$visible.department,
          staff = _this$base$visible.staff;
        return {
          depart: department.map(function (item) {
            return {
              department_id: item.id,
              department_name: item.name
            };
          }),
          staff: staff.map(function (item) {
            return {
              staff_id: item.id,
              staff_name: item.name
            };
          })
        };
      } catch (error) {
        return {};
      }
    },
    // 撤销校验之prop
    approvalCancel: function approvalCancel(vm) {
      return vm.base.is_allow_cancel === 4 ? 'allow_cancel_days' : 'is_allow_cancel';
    },
    // 是否展示撤销选项
    isViewCancel: function isViewCancel(vm) {
      return vm.base.is_allow_cancel === 1;
    },
    // 只有新的审批流可修改logo
    isNewFlow: function isNewFlow(vm) {
      return vm.base.type === 2;
    }
  },
  created: function created() {
    this.handleGetGroup();
  },
  methods: {
    handleGetGroup: function handleGetGroup() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGroup();
            case 2:
              _this.groups = _context.sent.data;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 选择人员 数据回显
    handleSelectPerson: function handleSelectPerson(_ref) {
      var dept_list = _ref.dept_list,
        staff_list = _ref.staff_list;
      this.base.visible.staff = staff_list.map(function (item) {
        return {
          id: item.staff_id,
          name: item.staff_name
        };
      });
      this.base.visible.department = dept_list.map(function (item) {
        return {
          id: item.department_id,
          name: item.department_name
        };
      });
    },
    // 部分人员弹出选人界面
    handlerChangePersonType: function handlerChangePersonType(value) {
      if (value) this.orgVisible = true;
    },
    // 表单校验
    doSubmit: function doSubmit() {
      var state;
      this.$refs.form.validate(function (valid) {
        state = valid;
      });
      return state;
    }
  }
};